import { useLocation } from "react-router-dom";
import { BookOpen, Home, MessageSquare, ArrowLeft } from "lucide-react";
import { SiteShell } from "@/components/layout/SiteShell";

/**
 * Branded 404 page. Renders inside the site shell so nav + footer stay
 * available, offers actionable next steps instead of a generic dead end.
 */
export default function NotFound() {
  const location = useLocation();
  return (
    <SiteShell>
      <section
        className="container-page py-20 sm:py-24 text-center"
        data-testid="not-found-page"
      >
        <div className="mx-auto inline-flex items-center justify-center h-14 w-14 rounded-full bg-[hsl(var(--sb-moss))] text-[hsl(var(--sb-forest-2))]">
          <BookOpen size={26} />
        </div>
        <div className="mt-4 text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
          Error 404
        </div>
        <h1 className="mt-2 font-serif text-5xl sm:text-6xl tracking-tight">
          This page is off-shelf.
        </h1>
        <p className="mt-4 max-w-xl mx-auto text-muted-foreground leading-relaxed">
          The page at{" "}
          <code className="rounded bg-muted px-1.5 py-0.5 text-xs">{location.pathname}</code>{" "}
          couldn't be found. It may have moved, or it might never have existed — perhaps a
          plot twist we haven't written yet.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-2">
          <a href="/" className="btn-primary" data-testid="not-found-home">
            <Home size={14} /> Home
          </a>
          <a href="/dashboard" className="btn-ghost border" data-testid="not-found-dashboard">
            <ArrowLeft size={14} /> Your dashboard
          </a>
          <a href="/contact" className="btn-ghost border" data-testid="not-found-support">
            <MessageSquare size={14} /> Contact support
          </a>
        </div>
      </section>
    </SiteShell>
  );
}
